<template>
  <span v-if="statusFilter(product.updateApproveStatus)">
    {{ statusFilter(product.updateApproveStatus) }}
  </span>
</template>

<script>
import Status from './Index';

export default {
  name: 'StatusOnSale',
  extends: Status,
};
</script>
